import { SectorBreakdown, SectorSLA } from './SectorBreakdown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { SLABadges } from './SLABadges';
import React from 'react';

interface SLAComplianceWidgetProps {
  data?: {
    global: {
      withinSla: number;
      outsideSla: number;
      rate: number;
    };
    bySector: SectorSLA[];
  };
}

export const SLAComplianceWidget: React.FC<SLAComplianceWidgetProps> = ({
  data,
}) => {
  if (!data) return null;

  const { global, bySector } = data;

  return (
    <div className='bg-white rounded-2xl shadow-lg border border-slate-100 p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex items-center gap-3 mb-8'>
        <div className='p-3 rounded-xl bg-violet-100 text-violet-600 group-hover:bg-violet-600 group-hover:text-white transition-all duration-500'>
          <AccessTimeIcon className='!w-5 !h-5' />
        </div>
        <div>
          <h3 className='text-base font-bold text-slate-500 uppercase tracking-wider'>
            Calidad del Servicio (SLA)
          </h3>
          <p className='text-sm text-slate-400 mt-0.5 font-medium'>
            Cumplimiento Global
          </p>
        </div>
      </div>

      <div className='flex-1 flex flex-col gap-8'>
        {/* Global Stats */}
        <div className='bg-slate-50/50 rounded-[2.5rem] p-6 border border-slate-100 flex flex-col items-center text-center shadow-inner'>
          <div className='relative'>
            <span className='text-6xl font-[1000] text-slate-900 tracking-tighter'>
              {global.rate.toFixed(1)}%
            </span>
            <div className='absolute -top-2 -right-2 w-5 h-5 bg-violet-500 border-4 border-white rounded-full animate-pulse shadow-lg shadow-violet-200' />
          </div>

          <div className='mt-2 mb-6 px-4 py-1 bg-violet-100/50 rounded-full border border-violet-100'>
            <span className='text-[10px] font-black text-violet-600 uppercase tracking-[0.2em]'>
              Tasa de Éxito
            </span>
          </div>

          <SLABadges
            withinSla={global.withinSla}
            outsideSla={global.outsideSla}
          />
        </div>

        {/* Sector Breakdown */}
        <SectorBreakdown sectors={bySector} />
      </div>
    </div>
  );
};
